<template lang="pug">
include ../pug/svg
div#certification(v-if="course")
	Form.wrapper(ref="certificationForm" :validation-schema="certificationSchema" v-slot="{ values, errors, meta }")
		div.c1
			div.field.upload.cert(:class="{on:certificationUrl}")
				button.bin.but.circ(v-if="certificationUrl" type="button" @click="onCertBin()")
					+svg(svg-filename="iconBin" aria-hidden="true" alt="Bin icon")
				figure
					img(v-if="certificationUrl" :src="certificationUrl" alt="Certificate")
					figcaption
						strong(data-label="Certificate / Template") Certificate / Template
						span Accepts: A4 JPG ({{maxFileSizeTidy}})
						+svg(svg-filename="iconUpload" aria-hidden="true" alt="Upload icon")
				div.recipient(v-if="recipientUse" :style="{'top':millimeterToPixel(recipientY)+'px','font-size':pointToMillimeter(recipientFontSize)+'px','color':'#'+recipientHex}") {{user.fullName}}
				div.course(v-if="courseUse" :style="{'top':millimeterToPixel(courseY)+'px','font-size':pointToMillimeter(courseFontSize)+'px','color':'#'+courseHex}") {{course.name}}
				div.signatory(v-if="signatoryUse" :style="{'top':millimeterToPixel(signatoryY)+'px','font-size':pointToMillimeter(signatoryFontSize)+'px','color':'#'+signatoryHex}") 
					strong {{signatoryName}}
					span , {{signatoryPosition}} 
				div.certificate(:style="{'top':millimeterToPixel(footerY)+'px','font-size':pointToMillimeter(footerFontSize)+'px','color':'#'+footerHex}") Certificate: {{certificateId}}
				div.awarded(:style="{'top':millimeterToPixel(footerY)+'px','font-size':pointToMillimeter(footerFontSize)+'px','color':'#'+footerHex}") Awareded: {{awarded}}
				DropZone(
					ref="dropzoneCert"
					:paramName="dzOpts.paramName"
					:url="dzOpts.url"
					:withCredentials="dzOpts.withCredentials"
					:uploadOnDrop="dzOpts.uploadOnDrop"
					:multipleUpload="dzOpts.multipleUpload"
					:maxFiles="dzOpts.maxFiles"
					:parallelUpload="dzOpts.parallelUpload"
					:acceptedFiles="dzOpts.acceptedFiles.logo"
					:maxFileSize="dzOpts.maxFileSize"
					@addedFile="onCertAdd"
					@sending="onCertSend"
				)
		div.c2
			div.fieldset
				h4 Recipient Name
				div.fieldset.c4.unbox
					FieldBoolean(name="recipientUse" v-model="recipientUse" label="Include" yesLabel="Yes" noLabel="No" @fieldUpdated="enableCheck")
					FieldText(name="recipientY" label="Vertical Offset" v-model="recipientY" :required="true" :disabled="!recipientUse" :cancelled="cancelled" append="mm" :numeric="true" :maxlength="3" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					FieldText(name="recipientFontSize" label="Font / Size" v-model="recipientFontSize" :required="true" :cancelled="cancelled" append="pt" :numeric="true" :minlength="2" :maxlength="2" :errors="errors" @keyup="enableCheck" @blur="enableCheck" :disabled="!recipientUse")
					div.field
						select(v-model="recipientHex" @change="enableCheck" :disabled="!recipientUse")
							option(v-for="colour in cssPallet" :value="colour.hex" :selected="colour.hex===recipientHex") {{ colour.name }}
						button.colour(type="button" disabled :style="{'background-color':'#'+recipientHex}")
						label Font / Colour
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Arrow icon")
				
			div.fieldset
				h4 Course Name
				div.fieldset.c4.unbox
					FieldBoolean(name="courseUse" v-model="courseUse" label="Include" yesLabel="Yes" noLabel="No" @fieldUpdated="enableCheck")
					FieldText(name="courseY" label="Vertical Offset" v-model="courseY" :required="true" :disabled="!courseUse" :cancelled="cancelled" append="mm" :numeric="true" :maxlength="3" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					FieldText(name="courseFontSize" label="Font / Size" v-model="courseFontSize" :required="true" :disabled="!courseUse" :cancelled="cancelled" append="pt" :numeric="true" :minlength="2" :maxlength="2" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					div.field
						select(v-model="courseHex" @change="enableCheck" :disabled="!courseUse")
							option(v-for="colour in cssPallet" :value="colour.hex" :selected="colour.hex===courseHex") {{ colour.name }}
						button.colour(type="button" disabled :style="{'background-color':'#'+courseHex}")
						label Font / Colour
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Arrow icon")
			
			div.fieldset
				h4 Signatory
				div.fieldset.c3.unbox
					FieldBoolean(name="signatoryUse" v-model="signatoryUse" label="Include" yesLabel="Yes" noLabel="No" @fieldUpdated="enableCheck")
					FieldText(name="signatoryName" label="Full Name" v-model="signatoryName" :required="true" :disabled="!signatoryUse" :cancelled="cancelled" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					FieldText(name="signatoryPosition" label="Positon / Organisation" v-model="signatoryPosition" :required="true" :disabled="!signatoryUse" :cancelled="cancelled" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
				div.fieldset.c3.unbox
					FieldText(name="signatoryY" label="Vertical Offset" v-model="signatoryY" :required="true" :disabled="!signatoryUse" :cancelled="cancelled" append="mm" :numeric="true" :maxlength="3" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					FieldText(name="signatoryFontSize" label="Font / Size" v-model="signatoryFontSize" :required="true" :disabled="!signatoryUse" :cancelled="cancelled" append="pt" :numeric="true" :minlength="2" :maxlength="2" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					div.field
						select(v-model="signatoryHex" @change="enableCheck" :disabled="!signatoryUse")
							option(v-for="colour in cssPallet" :value="colour.hex" :selected="colour.hex===signatoryHex") {{ colour.name }}			
						button.colour(type="button" disabled :style="{'background-color':'#'+signatoryHex}")
						label Font / Colour
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Arrow icon")

			div.fieldset
				h4 Certificate ID / Date
				div.fieldset.c3.unbox
					FieldText(name="footerY" label="Vertical Offset" v-model="footerY" :required="true" :disabled="!certificationUrl" :cancelled="cancelled" append="mm" :numeric="true" :maxlength="3" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					FieldText(name="footerFontSize" label="Font / Size" v-model="footerFontSize" :required="true" :disabled="!certificationUrl" :cancelled="cancelled" append="pt" :numeric="true" :minlength="2" :maxlength="2" :errors="errors" @keyup="enableCheck" @blur="enableCheck")
					div.field
						select(v-model="footerHex" @change="enableCheck" :disabled="!certificationUrl")
							option(v-for="colour in cssPallet" :value="colour.hex" :selected="colour.hex===footerHex") {{ colour.name }}
						button.colour(type="button" disabled :style="{'background-color':'#'+footerHex}")
						label Font / Colour
						+svg(svg-filename="iconArrow" aria-hidden="true" alt="Arrow icon")
</template>

<script>
import { Form, Field } from 'vee-validate';
import * as Yup from 'yup';
import { DropZone } from 'dropzone-vue';
import FieldText from '../components/FieldText';
import FieldBoolean from '../components/FieldBoolean';
//import { mapFields } from 'vuex-map-fields';
import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapCourseFields } = createHelpers({
	getterType: 'courses/getCourseField',
	mutationType: 'courses/updateCourseField',
});

export default {
	name: 'ManageLearningCourseCertification',
	components: {
		Form,
		Field,
		FieldText,
		FieldBoolean,
		DropZone,
	},
	props: ['course', 'cancelled'],
	emits: ['storeUpdated'],
	data () {
		const apiBaseUrl = (process.env.VUE_APP_VUE_ENV === 'development') ? process.env.VUE_APP_API_BASE_URL : window.location.origin + '/api';
		const req = 'Required';
		const num = 'Number required';
		const certificationSchema = Yup.object().shape({
			signatoryName: Yup.string().when(['signatoryUse'], {
				is: (signatoryUse) => signatoryUse,
				then: Yup.string().required(req),
				otherwise: Yup.string().nullable(),
			}),			
			signatoryPosition: Yup.string().when(['signatoryUse'], {
				is: (signatoryUse) => signatoryUse,
				then: Yup.string().required(req),
				otherwise: Yup.string().nullable(),
			}),			
			recipientY: Yup.number().typeError(num).required(req),
			recipientFontSize: Yup.number().typeError(num).required(req),
			courseY: Yup.number().typeError(num).required(req),
			courseFontSize: Yup.number().typeError(num).required(req),
			signatoryY: Yup.number().typeError(num).required(req),
			signatoryFontSize: Yup.number().typeError(num).required(req),
			footerY: Yup.number().typeError(num).required(req),
			footerFontSize: Yup.number().typeError(num).required(req),
		});
		
		return {
			apiBaseUrl,
			certificationSchema,
			dzOpts: {
				url: apiBaseUrl + '/courses/certification',
				withCredentials: true, // pass cookies
				paramName: 'file', // match to multerUpload
				uploadOnDrop: true,
				multipleUpload: false,
				maxFiles: 1,
				parallelUpload: 1,
				maxFileSize: 1000000, // (1 MB important for jsPDF)
				acceptedFiles: {
					cert: ['jpg'],
				},
			},
		};
	},
	watch: {
		course: {
			handler(course) {
				if (!course.certification) {
					// prevent acccess - redirect to settings
					this.$router.push({name:'ManageLearningCourseSettings', params:{courseId:course.id}});
				}
				
				this.$store.dispatch('gui/setHeader', {
					title: course.name,
					backRoute: {
						text: this.terminology('course','course','plural'),
						name: 'ManageLearning',
					},
				});		
			},
			deep: false,
		},
	},
	computed: {
		user() {
			return this.$store.state.auth.user;
		},
		cssPallet() {
			return Object.values(this.$store.state.gui.cssPallet);
		},
		...mapCourseFields([ // uses custom getter: getCourseField
			'certificationUrl',
			//'certificationData.orientation',
			'certificationData.recipientUse',
			'certificationData.recipientY',
			'certificationData.recipientFontSize',
			'certificationData.recipientHex',
			'certificationData.courseUse',
			'certificationData.courseY',
			'certificationData.courseFontSize',
			'certificationData.courseHex',
			'certificationData.signatoryUse',
			'certificationData.signatoryY',
			'certificationData.signatoryFontSize',
			'certificationData.signatoryHex',
			'certificationData.signatoryName',
			'certificationData.signatoryPosition',
			'certificationData.footerY',
			'certificationData.footerFontSize',
			'certificationData.footerHex',
		]),
//		maxFileSize() {
//			const sizes = this.$store.getters['gui/maxFileSizes'];
//			return sizes['image'].max || 0;
//		},
		maxFileSizeTidy() {
			return this.formatBytes(this.dzOpts.maxFileSize, 1);
		},
		certificateId() {
			return [this.course.organisationId, this.course.id, this.user.id, 1].join('_');
		},
		awarded() {
			const date = new Date();
			return date.toLocaleString('en-GB', {
				timeZone:'UTC',
				month:'long',
				year: 'numeric',
				day: 'numeric',
			});
		},
	},
	methods: {
		onCertAdd(item) {
			this.certificationUrl = item.file.name;
			this.enableCheck();
		},
		onCertSend(file, xhr, formData) {
			formData.append('id', this.course.id);
		},
		onCertBin() {
			this.$refs.dropzoneCert.removeFile(this.$refs.dropzoneCert.ids[0]);
			this.certificationUrl = null;
			//this.enableCheck();
			this.$emit('storeUpdated', { valid: false });
		},
		millimeterToPixel(mm) {
			// 1px = 0.5mm (in certificate preview)
			return (mm * 2);
		},
		pointToMillimeter(pt) {
			// 1pt = 0.352mm
			return this.millimeterToPixel(pt * 0.352);
		},
		formatBytes(bytes, decimals = 1) {
			if (bytes === 0) return '0 Bytes';
//			const k = 1024;
			const k = 1000;
			const dm = decimals < 0 ? 0 : decimals;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
		},
		hexColour(value) {
			// check for valid hex values (e.g(#FFF / #FFFFFF)
			const hexRegex = /^[0-9A-F]{6}$/i;
			const valid = hexRegex.test(value);
			
			return valid ? '#'+value : 'transparent';
		},
		enableCheck() {
			const {valid} = this.$refs.certificationForm.getMeta();
			
			this.$emit('storeUpdated', {
				screen: 'certification',
				valid,
			});
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
	},
}
</script>

<style lang="scss">
div#certification {
	width: 100%;
	form.wrapper {
		display: flex;
		margin-top: 30px;
		>.c2 {
			flex-grow: 1;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-bottom: auto;
/*			.field,
			.fieldset {
				width: calc(50% - 5px);
			}
			.fieldset {
				display: flex;
				justify-content: space-between;
				width: calc(50% - 5px);
			}*/
		}
	}
	h4 {
		width: 100%;
		margin: 10px 0 20px 0;
		&:first-of-type {
			margin-top: 0;
		}
	}
	.cert {
		>div {
			pointer-events: none;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			padding: 0 20px;
			text-align: center;
			font-family: Helvetica, Arial, sans-serif;
			opacity: 0;
			>* {
				font-family: inherit;
				font-size: inherit;
			}
			&.certificate {
				width: 50%;
				text-align: left;
			}
			&.awarded {
				left: 50%;
				width: 50%;
				text-align: right;
			}
		}
		&.on {
			>div {
				opacity: 1;
			}
		}
	}
	@media only screen and (max-width:599px) {
		form.wrapper {
			>.c2 {
				.field {
					max-width: none;
					width: 100%;
				}
			}
		}
	}
	@media only screen and (max-width:899px) {
		form.wrapper {
			flex-direction: column;
			.field {
				&.media {
					max-width: 600px;
					margin-left: auto;
					margin-right: auto;
				}
			}
		}
	}
	@media only screen and (min-width:900px) {
		form.wrapper {
			.c1 {
				width: 420px;
				min-width: 420px;
				margin-right: 20px;
			}
		}
	}	
	.field.upload.cert {
		width: 420px;
		height: 594px;
		figure {
			border-radius: 0;
			img {
				object-fit: contain;
			}
		}
		&:not(.on) {
			figcaption {
				position: relative;
				z-index: 0;
				&:before {
					z-index: -1;
					pointer-events: none;
					content: '';
					position: absolute;
					top: -10px;
					left: -10px;
					width: 420px;
					height: 574px;
					background: url(/img/pdf-certificate-thinkhub.jpg) 0 0 no-repeat;
					background-size: 100% auto;
					opacity: .5;
				}
			}
		}
		
	}
}
	/*div#settings {
		width: 100%;
		form.wrapper {
			display: flex;
			margin-top: 30px;
			.c2 {
				flex-grow: 1;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.field {
					width: calc(50% - 5px);
				}
			}
		}
		@media only screen and (max-width:599px) {
			form.wrapper {
				.c2 {
					.field {
						max-width: none;
						width: 100%;
					}
				}
			}
		}
		@media only screen and (max-width:899px) {
			form.wrapper {
				flex-direction: column;
				.field {
					&.media {
						max-width: 600px;
						margin-left: auto;
						margin-right: auto;
					}
				}
			}
		}
		@media only screen and (min-width:900px) {
			form.wrapper {
				.c1 {
					width: 410px;
					min-width: 410px;
					margin-right: 20px;
				}
			}
		}
	}
	.field {
		&.media {
			padding: 0;
			overflow: hidden;
			.label {
				position: absolute;
				top: 10px;
				left: 10px;
			}
			&.selected {
				.label {
					color: #FFF;
				}
			}
			picture {
				aspect-ratio: 16/9;
				display: block;
				margin: 0;
				background: url(/img/icon-photo.svg) center no-repeat;
				background-size: 30px 30px;
				&:after {
//					z-index: 1;
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: rgba(#FFF, 0.5);
					transition: opacity 0.3s ease-in-out;
					opacity: 0;
				}
			}
			.butdbl {
				z-index: 2;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				pointer-events: none;				
				opacity: 0;
			}
			&:hover {
				.butdbl,
				picture:after {
					pointer-events: auto;
					opacity: 1;
				}
			}
		}
	}
	*/
</style>
